@if (items.length > 2) {
<div class="p-t-4">
    <sticky-free [order]="10"
                 [stickyId]="'scroll-nav'"
                 [style.z-index]="11"
                 class="pos-relative">
        <div dragScroll
             class="no-wrap overflow-hidden left bg-col-w p-t-1 p-b-1 ">
            @for (item of items; track $index; let first = $first; let last = $last) {
            <button [class.m-l-4]="first"
                    [class.m-r-4]="last"
                    [ngClass]="isFocus(item) ? '_focus bg-col-1 col-w' : 'bg-col-5 col-1'"
                    type="button"
                    class="m-r-1 p2 p-t-2 p-b-2 p-l-3 p-r-3 _button"
                    (click)="scrollTo(item)">{{item.scrollNavTarget}}</button>
            }
        </div>
    </sticky-free>
</div>
}